var _defs, _g, _g2, _g3, _path, _path2, _g4, _g5, _path3, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvisors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9aac7e437e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.203125 5.203125 L 369.796875 5.203125 L 369.796875 369.796875 L 5.203125 369.796875 Z M 5.203125 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5762de48cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 5.203125 C 86.820312 5.203125 5.203125 86.820312 5.203125 187.5 C 5.203125 288.179688 86.820312 369.796875 187.5 369.796875 C 288.179688 369.796875 369.796875 288.179688 369.796875 187.5 C 369.796875 86.820312 288.179688 5.203125 187.5 5.203125 Z M 187.5 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7a7bdec40e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "68ea9d59dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 182.5 0.203125 C 81.820312 0.203125 0.203125 81.820312 0.203125 182.5 C 0.203125 283.179688 81.820312 364.796875 182.5 364.796875 C 283.179688 364.796875 364.796875 283.179688 364.796875 182.5 C 364.796875 81.820312 283.179688 0.203125 182.5 0.203125 Z M 182.5 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0820ef6f71"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 365,
    y: 0,
    height: 365
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa53f20697"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 156 105.03125 L 219 105.03125 L 219 168 L 156 168 Z M 156 105.03125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "147261ad67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225 181 L 303.984375 181 L 303.984375 251 L 225 251 Z M 225 181 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "818a4b9529"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 225 181 L 303.984375 181 L 303.984375 251 L 225 251 Z M 225 181 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cdb4061066"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70.734375 181 L 150 181 L 150 251 L 70.734375 251 Z M 70.734375 181 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "029badce09"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 70.734375 181 L 150 181 L 150 251 L 70.734375 251 Z M 70.734375 181 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9aac7e437e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5762de48cc)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0820ef6f71)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7a7bdec40e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#68ea9d59dc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa53f20697)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M 218.398438 136.152344 C 218.398438 141.617188 216.964844 146.988281 214.246094 151.691406 C 208.710938 161.28125 198.414062 167.234375 187.371094 167.234375 C 176.441406 167.234375 166.199219 161.371094 160.636719 151.933594 C 157.824219 147.171875 156.339844 141.714844 156.339844 136.152344 C 156.339844 119.015625 170.261719 105.074219 187.371094 105.074219 C 204.480469 105.074219 218.398438 119.015625 218.398438 136.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#147261ad67)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M 303.996094 234.910156 C 303.996094 235.953125 303.96875 236.992188 303.910156 238.019531 C 292.792969 244.632812 278.132812 249.179688 261.746094 250.585938 C 261.664062 230.808594 253.933594 212.222656 239.960938 198.230469 C 235.625 193.882812 230.84375 190.140625 225.722656 187.046875 C 233.082031 183.25 241.429688 181.105469 250.277344 181.105469 C 279.949219 181.105469 303.996094 205.195312 303.996094 234.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M 275.367188 149.117188 C 275.367188 153.695312 274.144531 157.984375 272.007812 161.683594 C 267.671875 169.191406 259.566406 174.246094 250.28125 174.246094 C 241.078125 174.246094 233.027344 169.277344 228.664062 161.875 C 226.460938 158.136719 225.191406 153.777344 225.191406 149.117188 C 225.191406 135.242188 236.425781 123.988281 250.28125 123.988281 C 264.136719 123.988281 275.367188 135.242188 275.367188 149.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M 256.695312 250.910156 L 256.695312 250.921875 C 256.695312 251.804688 256.679688 252.695312 256.644531 253.574219 C 238.273438 264.152344 214.023438 269.96875 188.167969 269.96875 C 161.835938 269.96875 136.378906 263.65625 118.066406 252.617188 C 118.050781 252.039062 118.042969 251.464844 118.042969 250.910156 L 118.042969 250.859375 C 118.0625 224.667969 132.632812 201.824219 154.078125 190.015625 C 163.964844 184.570312 175.3125 181.46875 187.371094 181.46875 C 199.429688 181.46875 210.777344 184.570312 220.664062 190.015625 C 242.121094 201.832031 256.695312 224.699219 256.695312 250.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#818a4b9529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M 303.996094 234.910156 C 303.996094 235.953125 303.96875 236.992188 303.910156 238.019531 C 292.792969 244.632812 278.132812 249.179688 261.746094 250.585938 C 261.664062 230.808594 253.933594 212.222656 239.960938 198.230469 C 235.625 193.882812 230.84375 190.140625 225.722656 187.046875 C 233.082031 183.25 241.429688 181.105469 250.277344 181.105469 C 279.949219 181.105469 303.996094 205.195312 303.996094 234.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cdb4061066)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M 134.777344 198.230469 C 120.832031 212.199219 113.101562 230.742188 112.996094 250.480469 C 96.480469 248.898438 81.78125 244.125 70.792969 237.269531 C 70.761719 236.488281 70.742188 235.699219 70.742188 234.910156 C 70.742188 205.195312 94.792969 181.105469 124.460938 181.105469 C 133.3125 181.105469 141.65625 183.25 149.015625 187.046875 C 143.894531 190.140625 139.117188 193.882812 134.777344 198.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M 149.546875 149.117188 C 149.546875 153.695312 148.324219 157.984375 146.1875 161.683594 C 141.851562 169.191406 133.746094 174.246094 124.460938 174.246094 C 115.257812 174.246094 107.207031 169.277344 102.84375 161.875 C 100.636719 158.136719 99.371094 153.777344 99.371094 149.117188 C 99.371094 135.242188 110.605469 123.988281 124.460938 123.988281 C 138.316406 123.988281 149.546875 135.242188 149.546875 149.117188 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#029badce09)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#231f20",
    d: "M 134.777344 198.230469 C 120.832031 212.199219 113.101562 230.742188 112.996094 250.480469 C 96.480469 248.898438 81.78125 244.125 70.792969 237.269531 C 70.761719 236.488281 70.742188 235.699219 70.742188 234.910156 C 70.742188 205.195312 94.792969 181.105469 124.460938 181.105469 C 133.3125 181.105469 141.65625 183.25 149.015625 187.046875 C 143.894531 190.140625 139.117188 193.882812 134.777344 198.230469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvisors);
export default __webpack_public_path__ + "static/media/Advisors.386d6f23bab3185070c52a22c74cb554.svg";
export { ForwardRef as ReactComponent };